export function bannerAlert () {
    const header = document.querySelector('.nav--transparent');
    const alerts = [...document.querySelectorAll('.banner__alert')]; // array for convenience

    if (!header || alerts.length === 0) return;

    function stack() {
        // header might be shorter than the minimum you want to leave visible
        let offset = Math.max(header.offsetHeight, 55);

        alerts.forEach(alert => {
        alert.style.position = 'absolute';        // make sure it’s absolute
        alert.style.top = `${offset}px`;
        offset += alert.offsetHeight;             // next banner starts after this one
        });
    }

    /* ────── run once after first paint ────── */
    window.addEventListener('load', stack);          // fires after images / fonts
    requestAnimationFrame(stack);                    // backup for very small assets

    /* ────── keep it correct on later changes ────── */
    window.addEventListener('resize', stack);        // viewport changes
    new ResizeObserver(stack).observe(header);       // header shrinks / grows
}

export default bannerAlert;